<template>
    <!--
    Container surrounding the main content of the page.
    Sets specific additional class if page has a sidebar.
    Sidebar type is set in sidebar component and populated
    by sidebar store properties
    -->
    <div class="container" :class="{
        'container--flex': sidebarType == 'flex',
        'container--tabs': sidebarType == 'tabs',
        'container--fixed': sidebarType == 'fixed',
    }">

        <slot />

    </div>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'Container',

    computed:
    {
        /**
         * Get sidebar type to set the right class for the container
         */
        ...mapState({
            sidebarType: ({ sidebar }) => sidebar.type,
        })
    },
}
</script>



// WEBPACK FOOTER //
// Container.vue?11d3a6f0